import axios from "axios";
import config from "@/config";

export default {
  getIncomeByCode(code) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/import_income_doc/detail/` + code, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  CheckDetail(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/import_income_doc/checkDetail`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getIncomeList(search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/import_income_doc`, {
      params: {
        s: search,
        page: page,
        from_date: fromDate,
        to_date: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateIncome(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`import_income_doc/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createIncome(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`import_income_doc`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteIncome(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/import_income_doc/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getExpensesList(search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/import_expensed_doc`, {
      params: {
        s: search,
        page: page,
        from_date: fromDate,
        to_date: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getExpensesByCode(code) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`import_expensed_doc/detail/` + code, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  createExpenses(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`import_expensed_doc`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateExpenses(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`import_expensed_doc/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteExpenses(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/import_expensed_doc/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  CheckDetailExpenses(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/import_expensed_docno/checkDetail`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getCheckinoutList(branch, dep, position, search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/getcheckinout/findByBranch`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        page: page,
        fromDate: fromDate,
        toDate: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  // _getTimePlanCheckIn2(branch, department, usercode,begin_date,end_date){
  //   const headers = new Headers();
  //   headers.append('Cintent-Type', 'application/json');
  //   const _token = sessionStorage.getItem("_token");
  //   headers.append('Authorization',_token);
  //   const _company_id = sessionStorage.getItem("_company_id");
  //   headers.append('X-TenantID',_company_id);

  //   const options = new RequestOptions();
  //   options.headers = headers;
  //   options.responseType = Respon

  // },
  deleteCheckinTime(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/checkinout/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createCheckinout(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/checkinout`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTakeLeaveList(branch, dep, position, search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/takeleave/findByBranch`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        page: page,
        fromDate: fromDate,
        toDate: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTakeLeaveByCode(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/takeleave/getbycode`, {
      params: {
        code: data,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createTakeleave(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/takeleave`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateTakeleave(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/takeleave`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteTakeleave(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/takeleave/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getChangeHolidayPlanList(branch, dep, position, search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/empholidayplan/findByBranch`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        page: page,
        fromDate: fromDate,
        toDate: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getChangePlanByCode(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/empholidayplan/getbycode`, {
      params: {
        code: data,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteChangeplan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/empholidayplan/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createChangePlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/empholidayplan`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateChangePlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/empholidayplan`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getOTPlanList(branch, dep, position, search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/otplan/findByBranch`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        page: page,
        fromDate: fromDate,
        toDate: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteOtplan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/otplan/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getOtPlanByCode(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/otplan/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createOtplan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/otplan`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateOtplan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/otplan`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getResignList(branch, dep, position, search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/resign/findByBranch`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        page: page,
        fromDate: fromDate,
        toDate: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteResign(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/resign/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getResignByCode(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/resign/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createResing(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/resign/`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateResing(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/resign/`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getSalaryApproveList(branch, dep, position, search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryapproval/findByBranch`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        page: page,
        fromDate: fromDate,
        toDate: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createSalaryApprove(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/salaryapproval/`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createSalaryApproveList(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/salaryapproval/import`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateSalaryApprove(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/salaryapproval/`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteSalaryApprove(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/salaryapproval/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createChangeWorkPlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/changeworkplan`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createChangeHolidayPlan(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/empchangeholiday`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getIncomeandExpensesList(branch, dep, position, search, page, fromDate, ToDate) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/empearning/findByBranch`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        page: page,
        fromDate: fromDate,
        toDate: ToDate,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getIncomeandExpensesByCode(code) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/empearning/getbycode`, {
      params: {
        code: code,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createIncomeandExpenses(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/empearning`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateIncomeandExpenses(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.put(`/empearning`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteIncomeandExpenses(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/empearning/` + data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTimePlanCheckIn(branchCode, department, usercode, begin_date, end_date) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    let uri = null;
    if (department == "" && usercode == "") {
      uri = "/checkintable/" + begin_date + "/" + end_date + "/" + branchCode + "/" + usercode;
    } else if (department == "" && usercode != "") {
      uri = "/checkintable/" + begin_date + "/" + end_date + "/" + branchCode + "/" + usercode;
    } else if (department != "" && usercode == "") {
      uri = "/checkintable/dep/" + begin_date + "/" + end_date + "/" + branchCode + "/" + department;
    } else if (department != "" && usercode != "") {
      uri = "/checkintable/" + begin_date + "/" + end_date + "/" + branchCode + "/" + department + "/" + usercode;
    } else {
      uri = "/checkintable/" + begin_date + "/" + end_date + "/" + branchCode;
    }

    return http.get(uri, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTimeChecklist(branchCode, department, usercode, begin_date, end_date) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    let uri = null;
    if (department == "" && usercode == "") {
      uri = "/salaryplan/" + begin_date + "/" + end_date + "/" + branchCode + "/" + usercode;
    } else if (department == "" && usercode != "") {
      uri = "/salaryplan/" + begin_date + "/" + end_date + "/" + branchCode + "/" + usercode;
    } else if (department != "" && usercode == "") {
      uri = "/salaryplan/dep/" + begin_date + "/" + end_date + "/" + branchCode + "/" + department;
    } else if (department != "" && usercode != "") {
      uri = "/salaryplan/" + begin_date + "/" + end_date + "/" + branchCode + "/" + department + "/" + usercode;
    } else {
      uri = "/salaryplan/" + begin_date + "/" + end_date + "/" + branchCode;
    }

    return http.get(uri, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  getTimeCheckInByEmp(begin_date, end_date, usercode) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    let uri = null;
    uri = "/salaryplan/Byuser/" + begin_date + "/" + end_date + "/" + usercode;
    return http.get(uri, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  getWHTkor(year, branch, dep) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/report/findPRD1DReport`, {
      params: {
        year: year,
        branch: branch,
        dep: dep,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  downloadTextFile(content, filename) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
        baseURL: config.API_URL,
    });
    const data = {
        content: content,
        filename: filename
    };
    return http.post(`/report/download-txt`, data, {
        params: {
            companyid: _company_guid,
        },
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + _token,
            "X-TenantID": _company_guid,
        },
        responseType: 'blob'  // สำคัญ: รับการตอบกลับเป็น binary data (blob)
    });
},
  getTaxDetailByMonths(branch, dep, from_date, to_date) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getTaxDetailByMonths`, {
      params: {
        branch: branch,
        dep: dep,
        from_date: from_date,
        to_date: to_date,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTaxDetailByYear(year, branch, dep) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getTaxDetailByYear`, {
      params: {
        branch: branch,
        dep: dep,
        year: year,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTaxDetailByYearAllEmp(year, branch, dep) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getTaxDetailByYearAllEmp`, {
      params: {
        branch: branch,
        dep: dep,
        year: year,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTaxDetailByYearAllEmpPage(year, branch, dep,offset,limit) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getTaxDetailByYearAllEmp`, {
      params: {
        branch: branch,
        dep: dep,
        year: year,
        companyid: _company_guid,
        offset:offset,
        limit:limit
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getTaxDetailByYearAllEmpCount(year, branch, dep) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getTaxDetailByYearAllEmpCount`, {
      params: {
        branch: branch,
        dep: dep,
        year: year,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  getSocialSecurityByYear(year, branch) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getSocialSecurityByYear`, {
      params: {
        year: year,
        branch: branch,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  getCommissionList(branch, dep, position, search, fromDate, toDate, comday) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`commission_doc`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        fromdate: fromDate,
        todate: toDate,
        comday: comday,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getCommissionDoc(branch, dep, position, search, fromDate, toDate, comday) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`commission_doc/getWorkplan`, {
      params: {
        branch: branch,
        dep: dep,
        position: position,
        search: search,
        fromdate: fromDate,
        todate: toDate,
        comday: comday,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getCommissionDocDetailByDocNo(doc_no) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`commission_doc/detail/` + doc_no, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  updateCommission(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`commission_doc/update`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  createCommission(data) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`commission_doc`, data, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteCommission(doc_no) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/commission_doc/` + doc_no, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  checkleave(emp_code, is_day, begin_date, end_date, leave_type) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/takeleave/getcheckleave`, {
      params: {
        emp_code: emp_code,
        is_day: is_day,
        begin_date: begin_date,
        end_date: end_date,
        leave_type: leave_type,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
};
